import { z } from "zod";

/** Never carries `isPlatformAdmin` — that's a fact about the *session*, not about the user as seen by others. See auth.ts's `meDtoSchema`. */
export const userDtoSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  createdAt: z.string().datetime(),
});

export type UserDto = z.infer<typeof userDtoSchema>;
